import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Footer, Button, Toast, toastStatus } from '@weirgroup/one-weir';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import LoginPage from '../modules/Login';
import HubPage from '../modules/Hub/containers/HubPage.container';
import ErrorPage from '../modules/ErrorPage/ErrorPage';
import styles from './main.module.css';
import { applicationRouteConstants } from '../shared/_constants';
import '../resources/stylesheets/main.css';
import SiteInformation from '../modules/SiteInformation';
import GlobalHeader from '../components/globalHeader';
import StickyMessage from '../components/stickyMessage';
import PrivateRoute from './protectedRoute';
import withAuthProvider from '../services/Auth/AuthProvider';
import {
  showModal,
  storeLanguageCode,
} from '../modules/Hub/Actions/HubActions';
import Modal from '../components/Modal/Modal';

import modalStyles from '../components/Modal/Modal.module.css';
import '../resources/stylesheets/ReactToastify.css';

// HOC to inject navigate and location hooks for class components
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} navigate={navigate} location={location} />;
  }
  return ComponentWithRouterProp;
}

class Main extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isAuth: null,
    };
  }

  componentDidUpdate(prevProps) {
    // Only react when authorised changes
    if (prevProps.Authorised !== this.props.Authorised) {
      const { t, Authorised, isLoggingOut } = this.props;

      // Show toast only on unexpected unauthorised
      if (
        prevProps.Authorised === true &&
        Authorised === false &&
        !isLoggingOut
      ) {
        toastStatus.error(t('UnAuthorisedUserToastMessage'));
      }
    }
  }

  /**
   * construct the modal body required for welcome Modal
   */
  modalBody() {
    const { t, showModal } = this.props;
    return (
      <div>
        <div className={modalStyles.modalBodyText1}>
          {t('modalH1BodyText_1')}
        </div>
        <div className={modalStyles.modalBodyText2}>
          {t('modalH1BodyText_2')}
        </div>
        <div className={modalStyles.modalBodyText2}>
          {t('modalH1BodyText_3')}
        </div>
        <div className={modalStyles.modalBodyText2}>
          {t('modalH1BodyText_4')}
        </div>
        <div className={modalStyles.headerText2}>{t('modalHeaderText_2')}</div>
        <div className={modalStyles.modalBodyText3}>
          {t('modalH2BodyText_1')}
        </div>
        <div className={modalStyles.modalButton}>
          <Button
            label={t('modalButtonLabel')}
            onClick={() => {
              showModal(false);
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    window.scrollTo(0, 0);
    const {
      t,
      isModal,
      isAuthenticated,
      storeLanguageCode,
      languageCode,
      showModal,
    } = this.props;
    const propVal = this.props;
    return (
      <div>
        <div className={styles.contentMain}>
          <div className={styles.headers}>
            <GlobalHeader
              isAuthenticated={isAuthenticated}
              storeLanguageCode={storeLanguageCode}
              languageCode={languageCode}
            />
            {isAuthenticated && (
              <StickyMessage
                showModal={propVal.showModal}
                logout={propVal.logout}
              />
            )}
          </div>
          <Routes>
            <Route
              path={`${applicationRouteConstants.DEFAULT}`}
              element={<LoginPage />}
            />
            <Route
              path={`${applicationRouteConstants.LOGIN}`}
              element={<LoginPage />}
            />
            <Route
              path={`${applicationRouteConstants.HUB}`}
              element={
                <PrivateRoute>
                  <HubPage />
                </PrivateRoute>
              }
            />
            <Route
              path={`${applicationRouteConstants.SiteInformation}`}
              element={<SiteInformation />}
            />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </div>
        <Footer
          appName={applicationRouteConstants.DEFAULT}
          year={t('footerYear')}
          title={t('footerTitle')}
          termsCondTitle={t('footerTermsCondTitle')}
          privStmtTitle={t('footerPrivStmtTitle')}
          cookPolTitle={t('footerCookPolTitle')}
          copyRightTitle={t('footerCopyRightTitle')}
        />
        <Modal
          body={this.modalBody()}
          title={t('modalHeaderText_1')}
          hideModal={() => {
            showModal(false);
          }}
          isModal={isModal}
        />
        <Toast width="632px" data-testid="toast" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isModal: state.HubReducer.isModal,
    isAuthenticated: state.AuthReducer.isAuthenticated,
    languageCode: state.HubReducer.languageCode,
    Authorised: state.AuthReducer.isAuthorised,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    showModal: (show) => {
      dispatch(showModal(show));
    },
    storeLanguageCode: (languageCode) => {
      dispatch(storeLanguageCode(languageCode));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(withAuthProvider(Main))));

Main.propTypes = {
  t: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  storeLanguageCode: PropTypes.func.isRequired,
  languageCode: PropTypes.string,
  Authorised: PropTypes.bool,
};

Main.defaultProps = {
  isAuthenticated: false,
  languageCode: 'en',
  Authorised: false,
};
